/**
 * Builds a catch wrapper to only run callback if response is not 401
 *
 * @param {Function} callback
 *
 * @return {Function}
 */
export default function ifNotUnauth(callback) {
  return response => {
    if (typeof response !== "object" || !("status" in response) || response.status !== 401) {
      callback(response);
    }
  };
}
